/**
 * Viewport-aware placement for hero pill type menus.
 * Prefers above the anchor so the discovery feed stays readable.
 *
 * @param {DOMRect} rect
 * @param {{ width?: number, height?: number, gap?: number }} [opts]
 * @returns {{ top: number, left: number, placement: 'above' | 'below' }}
 */
export function placeHeroPillMenu(rect, opts = {}) {
  const width = Number(opts.width) > 0 ? Number(opts.width) : 220;
  const height = Number(opts.height) > 0 ? Number(opts.height) : 44;
  const gap = Number(opts.gap) >= 0 ? Number(opts.gap) : 8;
  const vw = typeof window !== 'undefined' ? window.innerWidth : 390;
  const vh = typeof window !== 'undefined' ? window.innerHeight : 800;
  const pad = 8;

  const spaceAbove = rect.top - pad;
  const spaceBelow = vh - rect.bottom - pad;
  const preferAbove = spaceAbove >= height + gap || spaceAbove >= spaceBelow;

  let top = preferAbove ? rect.top - height - gap : rect.bottom + gap;
  top = Math.max(pad, Math.min(top, vh - height - pad));

  // Prefer aligning to anchor left; pull left if overflowing right edge.
  let left = rect.left;
  if (left + width > vw - pad) left = rect.right - width;
  left = Math.max(pad, Math.min(left, vw - width - pad));

  return {
    top,
    left,
    placement: preferAbove ? 'above' : 'below',
  };
}

/** Shared glass shell for hero pill type pickers. */
export const HERO_PILL_MENU_SHELL =
  'hero-pill-type-menu flex items-center gap-0.5 rounded-xl border border-cyan-400/25 bg-slate-950/50 p-1 shadow-[0_12px_40px_rgba(0,0,0,0.45)] ring-1 ring-white/10 backdrop-blur-xl';

export const HERO_PILL_MENU_OPTION =
  'inline-flex shrink-0 items-center gap-1.5 rounded-lg px-2 py-1.5 text-[10px] font-semibold uppercase tracking-wide transition';

export const HERO_PILL_MENU_OPTION_IDLE =
  'text-slate-300/95 hover:bg-white/10 hover:text-white';

export const HERO_PILL_MENU_OPTION_ACTIVE =
  'bg-cyan-400/20 text-cyan-50 ring-1 ring-cyan-300/35';
